import { IAssetsLanding } from '../types/landing.type';
import $http from '../services/AxiosInstance';
import { IAssetsOption } from '../types/optionsSelect.type';
import { ICurrency, ICurrencyOption } from '../types/currency.type';
import { IBussinessUnit, IBussinessUnitOption } from '../types/businessUnit.type';
import { saveAs } from 'file-saver';

interface Params {
  page?: number;
  searchData?: {
    search?: string | null;
    companyId?: number | null;
    managerId?: number | null;
    startDate?: string | null;
    endDate?: string | null;
    status?: string | null;
  } | null;
}

class CertificatesRepository {
  static async getAssets(): Promise<IAssetsOption[]> {
    try {
      let url = '/certificate/assets';

      const response = await $http.get(url);

      return response.data.map((asset: IAssetsLanding) => ({
        id: asset.id,
        nombre: asset.description,
      }));
    } catch (errors: any) {
      throw Error;
    }
  }
  static async getCurrencies(): Promise<ICurrencyOption[]> {
    try {
      let url = '/certificate/currencies';

      const response = await $http.get(url);

      return response.data.map((curr: ICurrency) => ({
        id: curr.id,
        nombre: curr.currency,
      }));
    } catch (errors: any) {
      throw Error;
    }
  }
  static async getBusinessUnits(): Promise<IBussinessUnitOption[]> {
    try {
      let url = '/certificate/businessUnits';

      const response = await $http.get(url);

      return response.data.map((businessUnit: IBussinessUnit) => ({
        id: businessUnit.id,
        nombre: businessUnit.description,
      }));
    } catch (errors: any) {
      throw Error;
    }
  }
  static async createCertificate(data: any): Promise<boolean> {
    try {
      let url = '/certificate';

      const response = await $http.post(url, data);
        if (response.status === 200) {
            return true;
        }
        return false;
    } catch (errors: any) {
      throw Error;
    }
  }
  async getCertificates(params: Params) {
    try {
      let url = `/certificate?page=${params.page}`;

      if (params.searchData !== null) {
        if (!!params.searchData?.search && params.searchData?.search.trim() !== '') {
          url += `&search=${params.searchData?.search ?? ''}`;
        }
        if (!!params.searchData?.companyId) {
          url += `&companyId=${params.searchData.companyId}`;
        }
        if (!!params.searchData?.managerId) {
          url += `&managerId=${params.searchData.managerId}`;
        }
        if (!!params.searchData?.startDate) {
          url += `&startDate=${params.searchData.startDate}`;
        }
        if (!!params.searchData?.endDate) {
          url += `&endDate=${params.searchData.endDate}`;
        }
        if (!!params.searchData?.status) {
          url += `&status=${params.searchData.status}`;
        }
      }

      const response = await $http.get(url);
      return response;
    } catch (errors: any) {
      return errors;
    }
  }
  async downloadPDF(id: number, name: string) {
    try {
      const response = await $http.post(`/certificate/pdf`, { id }, {
        responseType: 'blob',
      });

      const filename = `${id}.pdf`
      saveAs(response.data, filename);
    } catch (error) {
      console.error('Error al descargar el PDF:', error);
    }
  }
  async updateCertifcate(id: number) {
    const response = await $http.patch(`/certificate/cancel/${id}`);
    return response.data
  }

  async getExcelPolicies({ search, toExcel, startDate, endDate, status }: {
    search: string | null;
    toExcel: boolean;
    startDate: string | null;
    endDate: string | null;
    status?: string | null;
  }) {
    async function getExcel(url: string, params: any) {
      const headers = { ...params.headers };
      delete headers['Content-Type'];

      const config = {
        headers,
        params,
        responseType: 'blob' as any,
      };

      if (params) {
        config.params = params;
      }

      return await $http.get(url, config);
    }
    try {

      const params = new URLSearchParams();
      
      params.append('toExcel', String(toExcel));
      if (search !== undefined && search !== null) {
        params.append('search', String(search));
      }
      if(startDate !== null) {
        params.append('startDate', startDate);
      }
      if(endDate !== null) {
        params.append('endDate', endDate);
      }
      if (status !== undefined && status !== null) {
        params.append('status', status);
      }

      const { data } = await getExcel('/certificate', params);

      saveAs(data, `Certificados.xlsx`);
    }
    catch (error) {
      return error;
    }
  }

}


export default CertificatesRepository
;
